export default __webpack_public_path__ + "static/media/jcb.0cfef004.svg";